import index from './index.vue';

export default [
  {
    path: '/update_log',
    name: 'Update Log',
    component: index,
  },
];
